export default __webpack_public_path__ + "static/media/chat.4c22a7ae.png";